/**
 * Обработка ответа PUT/POST /lsystem/api/v1/drives-in-route (только химчистка / lsystem).
 */

export function isSaveBlocked(data) {
    return Boolean(data?.error?.length) && !data?.route_id;
}

export function isSaveSuccessful(data) {
    return Boolean(data?.route_id);
}

export function getSaveNotificationMessage(data) {
    if (data?.warnings?.length) {
        return data.warnings.join('\n');
    }
    if (data?.error?.length) {
        return data.error.join('\n');
    }
    return null;
}

export function getExcludedOrderIds(data) {
    if (!data?.excluded_order_ids?.length) {
        return [];
    }
    return data.excluded_order_ids.map((id) => Number(id));
}
